<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="isMobile"
    :hide-overlay="isMobile"
    width="520"
    scrollable
  >
    <v-card class="pa-5">
      <v-container class="pa-0 d-flex justify-space-between align-center mb-3">
        <v-card-text class="pa-0 text-body-1">
          {{ $t("prevInvoice") }}
          <span v-if="invoiceNumber" class="text-caption grey--text mr-1">
            ({{ invoiceNumber }})
          </span>
        </v-card-text>
        <v-icon size="20" style="cursor: pointer" @click="onCancel"> mdi-close </v-icon>
      </v-container>

      <div class="reprint-preview-frame">
        <iframe
          v-if="previewHtml"
          class="reprint-preview-iframe"
          :srcdoc="previewHtml"
          title="reprint-preview"
        />
        <div v-else class="reprint-preview-empty text-caption grey--text">
          {{ $t("no-data") }}
        </div>
      </div>

      <v-container class="pa-0 d-flex justify-end align-center gap-2 mt-5">
        <v-btn color="error" outlined height="32" @click="onCancel">
          {{ $t("cancel") }}
        </v-btn>
        <v-btn
          color="primary"
          height="32"
          :disabled="!html"
          :loading="loading"
          @click="onConfirm"
        >
          {{ $t("print") }}
        </v-btn>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import General from "@/Mixins/general";

export default {
  name: "ReprintPreviewDialog",
  mixins: [General],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    html: {
      type: String,
      default: "",
    },
    invoiceNumber: {
      type: [String, Number],
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    previewHtml() {
      if (!this.html) return "";
      const hideScrollStyle = `<style id="hide-reprint-scrollbar">
html, body {
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;
}
html::-webkit-scrollbar,
body::-webkit-scrollbar,
*::-webkit-scrollbar {
  display: none !important;
  width: 0 !important;
  height: 0 !important;
}
</style>`;
      if (/<\/head>/i.test(this.html)) {
        return this.html.replace(/<\/head>/i, `${hideScrollStyle}</head>`);
      }
      return `${hideScrollStyle}${this.html}`;
    },
  },
  methods: {
    onCancel() {
      this.dialog = false;
      this.$emit("cancel");
    },
    onConfirm() {
      if (!this.html) return;
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.reprint-preview-frame {
  width: 100%;
  height: 420px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  background: #fafafa;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.reprint-preview-frame::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.reprint-preview-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.reprint-preview-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
